
import { supabase } from '@/integrations/supabase/client';

/**
 * Check if a site is available for the given date range
 */
export async function checkSiteAvailability(
  siteId: string,
  startDate: Date,
  endDate: Date
): Promise<boolean> {
  try {
    // Format dates as YYYY-MM-DD for the database function
    const startDateStr = startDate.toISOString().split('T')[0];
    const endDateStr = endDate.toISOString().split('T')[0];
    
    // Call the database function to check availability
    const { data, error } = await supabase
      .rpc('check_site_availability_for_dates', {
        site_id: siteId,
        check_start_date: startDateStr,
        check_end_date: endDateStr
      });
    
    if (error) {
      console.error('Error checking site availability:', error);
      throw new Error(`Failed to check availability: ${error.message}`);
    }
    
    return data === true;
  } catch (error) {
    console.error('Error in checkSiteAvailability:', error);
    throw error;
  }
}

/**
 * Get conflicting bookings for a site and date range
 */
export async function getConflictingBookings(
  siteId: string,
  startDate: Date,
  endDate: Date
) {
  try {
    const { data, error } = await supabase
      .from('site_bookings')
      .select('id, booking_id, customer_name, start_date, end_date')
      .eq('site_id', siteId)
      .eq('payment_status', 'paid')
      .gte('end_date', startDate.toISOString().split('T')[0])
      .lte('start_date', endDate.toISOString().split('T')[0]);
    
    if (error) {
      console.error('Error fetching conflicting bookings:', error);
      throw new Error(`Failed to fetch bookings: ${error.message}`);
    }
    
    return data || [];
  } catch (error) {
    console.error('Error in getConflictingBookings:', error);
    throw error;
  }
}
